<template>
	<v-layout
		class="section-header"
		:class="{ 'scrolling': scrolled, 'no-banner': !bannerVisible }"
	>
		<v-flex xs12 class="container">
			<v-layout wrap>
				<v-flex md7 xs2>
					<img 
						:src="`${$S3}logo-text-green.svg`" 
						alt="logo"
						class="desktop"
						height="30">
					<img 
						:src="`${$S3}logo-min.svg`"
						class="mobile"
						height="37"
						alt="logo">	
				</v-flex>
				<v-flex md5 xs10>
					<div class="wrapper-buttons">
						<div 
							class="pat-5 btn-app" 
							:class="{scrolling: scrollingOne}">
							<div class="wrapper-link">
								<div class="disabled-btn" v-if="disabledRegisterApp"></div>
								<a
									:href="disabledRegisterApp ? '#' : '#generate-app'"
									class="btn-link">ACTIVA TU APP</a>
							</div>
						</div>
						<div class="pat-5">
							<div class="wrapper-link">
								<div class="disabled-btn" v-if="disabledPayment"></div>
								<a 
									:href="disabledPayment ? '#' : linkPayment"
									class="btn-link"
									target="_blank"
									>REALIZAR PAGO</a>
							</div>
						</div>
						<div xs4 class="desktop">
							<div>
								<a :href="linkGooglePlay" target="_blank">
									<img :src="`${$S3}icon-google.png`" alt="google play" height="47">
								</a>
							</div>
						</div>
					</div>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>
<script>
function created() {
	window.addEventListener('scroll', this.handleScroll);
}

function destroyed() {
	window.removeEventListener('scroll', this.handleScroll);
}

function handleScroll() {
	if (window.innerWidth < 934) {
		this.scrolled = window.scrollY > 750;
		this.scrollingOne = window.scrollY > 2600;
	} else {
		this.scrolled = window.scrollY > 400;
		this.scrollingOne = window.scrollY > 1350;
	}
}

function data() {
	return {
		scrolled: false,
		scrollingOne: false,
		linkGooglePlay: process.env.LINK_GOOGLE_PLAY,
		linkPayment: process.env.LINK_PAYMENT,
	};
}

export default {
	name: 'section-header',
	created,
	data,
	destroyed,
	methods: {
		handleScroll,
	},
	props: {
		bannerVisible: {
			default: true,
			type: Boolean,
		},
		disabledRegisterApp: {
			type: Boolean,
			default: false,
		},
		disabledPayment: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
	.section-header {
		background: color(white);
		box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.09);
		padding: 10px 7%;
		position: fixed;
		top: -100px;
		transition: all 0.5s ease;
		width: 100%;
		z-index: 999;

		&.scrolling {
			top: 68px;

			&.no-banner {
				top: 0px;
			}
		}

		@media (max-width: 830px) {
			padding: 10px;
			top: -105px;

			&.scrolling {
				top: 123px;

				&.no-banner {
					top: 0px;
				}
			}
		}
	}

	.btn-link {
		background-color: color(title-green);
		border-radius: 7px;
		color: color(white);
		display: inline-block;
		font-size: 13px;
		margin-right: 13px;
		padding: 8px 4px;
		text-align: center;
		text-decoration: none;

		@media (max-width: 830px) {
			margin-right: 3px;
		}
	}

	.pat-5 {
		padding-top: 5px;
	}

	.wrapper-buttons {
		display: flex;
		justify-content: flex-end;

		@media (max-width: 830px) {
			justify-content: space-around;
		}
	}

	.btn-app {
		opacity: 0;
		transition: all 0.3s ease;

		&.scrolling {
			opacity: 1;
		}
	}

	.desktop {
		@media (max-width: 830px) {
			display: none;
		}
	}

	.mobile {
		display: none;
		@media (max-width: 830px) {
			display: block;
		}
	}

	.disabled-btn {
		background-color: color(white);
		border-radius: 7px;
		bottom: 0;
		cursor: not-allowed;
		left: 0;
		opacity: 0.5;
		position: absolute;
		right: 0;
		top: 0;
	}

	.wrapper-link {
		position: relative;
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/section-header.vue